import ProductTransformer from './ProductTransformer';

export default class ProductOrderSelectionTransformer extends ProductTransformer {
  static addFootnote(fn, product) {
    if (fn.name === 'footNoteSelection') {
      product.footnotes.push(fn.text);
    }
  }

  static parseFootnotes(product, footnotes) {
    [
      'productName',
      'productDescriptionSelection',
      'providerName',
      'productRequirementsDetails',
      'priceInformation',
      'promotionPriceOverrideText',
      'regularPriceOverrideText',
      'minimumCommitmentPeriodOverrideText',
      'minimumCommitmentPeriodText',
      'beforeOptinInfoText',
      'dataTransferDenialText',
      'dataTransferDenialLinkText',
      'redirectHint',
      'fixedLineNumberText',
      'fixedLineNumberLabel',
    ].forEach(field => {
      product.texts[field] = footnotes.parse(product.texts[field]);
    });
  }
}
